import React, { useState } from "react";

import { Grid } from "@material-ui/core";
import ReactSelect from "react-select";

import { Label } from "components/Form/FormikControls";
import { Column } from "components/Layout";
import { Paper } from "components/Paper";
import { TitleText } from "components/Text";

import { MultiSaleReportOptions } from "constants/reports";

import { MultiSaleReportForm } from "./form";

export function MultiSaleReportComponent() {
  const [selectedReportSlug, setSelectedReportSlug] = useState(
    MultiSaleReportOptions[0],
  );

  const onChange = newValue => {
    setSelectedReportSlug(newValue);
  };

  return (
    <Column padding={2}>
      <Paper>
        <Grid container>
          <Grid item xs={12} container justifyContent="center">
            <TitleText>Multi Sale Reports</TitleText>
          </Grid>
          <Grid xs={12} item container>
            <Column fullWidth>
              <Label>Select Report To Run</Label>
              <ReactSelect
                options={MultiSaleReportOptions}
                onChange={onChange}
                value={selectedReportSlug}
              />
            </Column>
          </Grid>
        </Grid>

        <MultiSaleReportForm reportSlug={selectedReportSlug.value} />
      </Paper>
    </Column>
  );
}
